import React from "react";
import { Handle } from "react-flow-renderer";
import { BottleIcon, CloseIcon, PomacesIcon, TankIcon } from "../../Generic";
import { DestLotDetail } from "../../OperationsDetail/Details";
import useLabels from "../../../hooks/useLabels";

import "./styles/index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { selectBottleTypes, selectConfigs } from "../../../context/selectors";
import { format } from "date-fns";

const NodeWrapper = ({ data }) => {
  const [getLabel] = useLabels();
  const configs = useSelector(selectConfigs);
  const bottleTypes = useSelector(selectBottleTypes);

  const getColor = (color = "RED") => {
    switch (color) {
      case "RED":
        return "#64242e";
      case "ROSE":
        return "#c74f59";
      case "WHITE":
        return "#f9d573";
      default:
        return "#64242e";
    }
  };

  const getVolume = (bottle_type) => {
    const volume = parseFloat(bottleTypes?.find(t => t?.value === bottle_type)?.volume || 0.75); // e.g., 0.75
    return volume;
  }

  const getBottlesCount = (tank) => {
    const totalQtyUsedIncludingCurrent = Number(tank?.quantity) || 0;
    const volume = getVolume(tank?.bottle_type);

    return Math.ceil(totalQtyUsedIncludingCurrent / volume);
  }

  if (!data) return;

  const {
    operation_id,
    operation_type,
    completion_date,
    tank,
    lot,
    pomace,
    treatments,
    handleIds,
  } = data; // Expect handleIds as part of the node data

  return (
    <div className="node_wrapper">
      {operation_type !== undefined && !tank?.is_dest && !pomace &&(
        <div
          className={`node_wrapper_header color_${(
            tank ||
            lot ||
            ""
          )?.color?.toLowerCase()}`}
        >
          {getLabel(`operationType${operation_type}`)}
        </div>
      )}
      {completion_date && (
        <div className={`node_wrapper_header date`}>
          {format(
            new Date(completion_date || null),
            configs.hourShortDateFormat
          )}
        </div>
      )}
      {(operation_type === "DESTEMMING" || operation_type === "NEW_LOT") &&
        lot &&
        !tank && (
          <DestLotDetail
            lot={{
              label: lot?.source_batch_name,
              color: lot?.source_batch_color || lot?.color,
              percentages: lot?.source_batch_percentages,
              varieties: lot?.source_batch_varieties,
              origins: lot?.source_batch_origins,
              years: lot?.source_batch_years,
              initial_quantity: lot?.source_batch_initial_quantity,
              real_final_quantity: lot?.source_batch_final_quantity, // - lot.quantity,
            }}
            isRecap={true}
            isAdditional={true}
            isDestemming={true}
          />
        )}
      {(operation_type === "DESTEMMING" || operation_type === "NEW_LOT") &&
        pomace &&
        !tank && (
          <PomacesIcon
            data={pomace}
          />
        )}
      {(!["DESTEMMING", "NEW_LOT", "TREATMENT", "ANALYSIS", "BOTTLING", "CLOSING"].includes(
        operation_type
      ) ||
        (["DESTEMMING", "NEW_LOT"].includes(operation_type) &&
          tank?.is_dest)) &&
        !tank?.hide && <TankIcon tank={{ ...tank }} />}
      {operation_type === 'BOTTLING' && tank?.is_dest &&
        !tank?.hide && <BottleIcon isTracking={true} { ...tank } volume={getVolume(tank?.bottle_type) + ' L'} bottleCount={getBottlesCount(tank)}/>}
      {operation_type === 'CLOSING' && tank?.is_dest &&
        !tank?.hide && <CloseIcon isTracking={true} data={tank} />}
      {/* {!['TREATMENT', 'ANALYSIS'].includes(operation_type) && !tank?.hide &&
        <TankIcon tank={{ ...tank }} />
      } */}
      {["TREATMENT", "ANALYSIS"].includes(operation_type) && (
        <div className="node_wrapper treatment">
          <span className="icon">
            <FontAwesomeIcon
              size={"2xl"}
              icon={operation_type === "ANALYSIS" ? "fa-flask-vial" : "fa-tablets"}
              color={getColor(treatments?.[0]?.color)}
            />
          </span>
        </div>
      )}
      <Handle
        type="target"
        position="top"
        id={handleIds?.target} // Dynamic target handle ID
        style={{
          background: "#555",
          opacity:
            operation_type === "DESTEMMING" || operation_type === "NEW_LOT"
              ? 0
              : 100,
        }} // opacity is a trick to hide the handle without impacting the layout
        isConnectable={false} // Disable manual connections for source
      />
      <Handle
        type="source"
        position="bottom"
        id={handleIds?.source} // Dynamic source handle ID
        style={{ background: "#555" }}
        isConnectable={false} // Disable manual connections for source
      />
    </div>
  );
};

export default NodeWrapper;
